<template>
  <lm-icon-button
    class="LmSummaryComment"
    :class="{'new-comments': newComments}"
    icon="chat_bubble_outline"
    :label="numComments"
    :tooltip="tooltip"
    @click="$emit('click', $event)"
  />
</template>

<script>
import LmIconButton from '@/components/ui/LmIconButton'
export default {
  name: 'LmSummaryComment',
  components: {LmIconButton},
  props: {
    numComments: {
      type: String,
      required: true
    },
    newComments: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.LmSummaryComment {
  &.new-comments:before {
    content: '';
    position: absolute;
    top: -3px;
    left: 4px;
    width: 11px;
    height: 11px;
    background-color: theme('colors.highlight');
    border: 2px solid white;
    border-radius: 100%;
  }
}
</style>
